const ITEMS = [
    "12.8B EVENTS DELIVERED",
    "99.999% SLA",
    "<12MS P99 LATENCY",
    "ZERO-DATA-LOSS ARCHITECTURE",
    "AUTOMATIC RETRIES",
    "INSTANT REPLAY",
    "HMAC SIGNATURES",
    "35 EDGE REGIONS",
];

const Row = ({ ariaHidden = false }) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
        {ITEMS.map((item) => (
            <span key={item + (ariaHidden ? "-b" : "-a")} className="flex items-center">
                <span className="font-display px-8 text-sm font-bold uppercase tracking-[0.3em] text-slate-600">
                    {item}
                </span>
                <span className="text-cyan-500/50">✦</span>
            </span>
        ))}
    </div>
);

export default function Marquee() {
    return (
        <section
            data-testid="metrics-marquee"
            className="mask-fade-x relative overflow-hidden border-y border-slate-800/70 bg-slate-950/40 py-5"
        >
            <div className="marquee-track flex w-max">
                <Row />
                <Row ariaHidden />
            </div>
        </section>
    );
}
